<aside class="operational-warning-card" [attr.data-scope]="warning.scope || null">
    <div *ngIf="scopeLabel || warning.condition" class="operational-warning-card__meta">
        <span *ngIf="scopeLabel" class="operational-warning-card__scope">{{ scopeLabel }}</span>
        <span *ngIf="warning.condition" class="operational-warning-card__condition">{{ warning.condition }}</span>
    </div>

    <dl class="operational-warning-card__fields">
        <div class="operational-warning-card__field">
            <dt>Problem</dt>
            <dd>{{ warning.problem }}</dd>
        </div>
        <div class="operational-warning-card__field">
            <dt>Impact</dt>
            <dd>{{ warning.impact }}</dd>
        </div>
        <div class="operational-warning-card__field">
            <dt>Recommended action</dt>
            <dd>{{ warning.recommendedAction }}</dd>
        </div>
    </dl>
</aside>
